import React, { useState, useContext } from "react";
import styles from "./styles/PosSummaryTransaction.module.css";
import DataContext from "../../../context/DataContext";
import {
    formatDateToLocalDate,
    formatTimeToLocalTime,
} from "../../../utils/utils";
import { calculateValues } from "../../../utils/utils";
import POSDataContext from "../../../context/POSDataContext";
import ButtonExpand from "../button_expand/ButtonExpand";
import CloseButton from "../close_button/CloseButton";
import useNumberFormat from "../../../hooks/useNumberFormat";

import { ReactComponent as IconBill } from "../../../assets/bill-1.svg";

import { ReactComponent as IconClock } from "../../../assets/clock.svg";
import { ReactComponent as IconGavel } from "../../../assets/gavel.svg";
import { ReactComponent as IconTicket } from "../../../assets/ticket.svg";
import { ReactComponent as IconDate } from "../../../assets/calendar.svg";

/**
 *
 */
const PosSummaryTransaction = ({
    transaction,

    currency,

    handleDelete,
    isLoadingPos,
}) => {
    const formatNum = useNumberFormat();
    return (
        <div
            role="button"
            className={`${styles.main_ticket_container}   flex-container`}
        >
            <div className={`${styles.info_container} v-flex-container`}>
                <div
                    className={`${styles.ticket_info} ${styles.transaction_tag}`}
                >
                    <span>
                        <IconTicket
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {transaction?.referenceNo}
                </div>

                <div className={`${styles.ticket_info}  ${styles.date_tag}`}>
                    <span>
                        <IconDate
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {`${formatDateToLocalDate(transaction?.paymentDateTime)}`}
                </div>
                <div className={`${styles.ticket_info}  ${styles.time_tag}`}>
                    <span>
                        <IconClock
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {formatTimeToLocalTime(transaction?.paymentDateTime)}
                </div>
                <div className={`${styles.ticket_info} ${styles.amount_tag}`}>
                    <span>
                        <IconBill
                            className={`${styles.ticket_icon} icon-component`}
                        />
                    </span>
                    {`${currency}${formatNum(transaction?.totalAmount)}`}
                </div>
            </div>
            <div className={`${styles.close_button_container} flex-container`}>
                <CloseButton
                    tab={true}
                    tabBackground={true}
                    onClickFuction={() =>
                        handleDelete(transaction?.referenceNo)
                    }
                    disableHTML={isLoadingPos}
                />
            </div>
        </div>
    );
};

export default PosSummaryTransaction;
